import './imageDataPolyfill';

export { default as decode, isBlurhashValid } from "./decode";